import { render } from "./AuthButtons.vue?vue&type=template&id=0619509d&scoped=true&ts=true"
import script from "./AuthButtons.vue?vue&type=script&lang=ts"
export * from "./AuthButtons.vue?vue&type=script&lang=ts"

import "./AuthButtons.vue?vue&type=style&index=0&id=0619509d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0619509d"]])

export default __exports__